import React, { useCallback } from 'react';
import {t} from '@lingui/macro';
import {getOptions, SelectHelper} from "./utils/helper";
import {ReadOnlySupport} from "./utils/ReadOnlySupport";
import {Select as AntSelect, Tag} from "antd";
import {ReadOnlyBox} from "./utils/ReadOnlyBox";

function SelectReadOnly(props) {
    const { value, bordered, placeholder, className, mode, disabled } = props;
    const { options, children, optionLabelProp } = props;

    function getLabel(value) {
        const newOptions = getOptions(options, children, optionLabelProp) || [];
        if (mode === 'tags') {
            return value.map(v => {
                console.log('aaa tag value', {v, newOptions});
                return (
                    <Tag key={v}>
                        {newOptions.find(option => option.value === v)?.label || v}
                    </Tag>
                );
            });
        }

        return newOptions.find(option => option.value === value)?.label || value;
    }

    if (bordered) {
        const shouldWrap = mode === 'tags';
        return (
            <ReadOnlyBox disabled={disabled} className={shouldWrap ? 'wrap-text' : ''}>
                { getLabel(value) }
            </ReadOnlyBox>
        );
    }
    return getLabel(value) || (
        <div className={`ant-custom-readonly ${className}`}>
            <span className="placeholder">{placeholder || t`No Data`}</span>
        </div>
    );
}

SelectReadOnly.defaultProps = {
    bordered: true,
};

export const Select = React.memo(React.forwardRef((props, ref) => {
    const { children, popupContainerId, dispatch, ...restProps } = props;

    const whenReadOnly = useCallback(() => <SelectReadOnly {...props} />, [props]);

    const notReadOnly = useCallback(() => (
        <AntSelect
            {...restProps}
            ref={ref}
            getPopupContainer={SelectHelper.getPopupContainer(popupContainerId)}
        >
            {children}
        </AntSelect>
    ), [children, popupContainerId, ref, restProps]);

    return <ReadOnlySupport
        {...props}
        whenReadOnly={whenReadOnly}
        notReadOnly={notReadOnly}
    />;
}));

Select.Option = AntSelect.Option;
Select.OptGroup = AntSelect.OptGroup;
